import { useCallback, useEffect, useRef, useState } from 'react';
import { insertSavedPromptText } from '../utils/composerDraft';

interface UseComposerDraftResult {
  composerDraft: string;
  setComposerDraft: (draft: string) => void;
  composerInputRef: React.RefObject<HTMLTextAreaElement>;
  insertSavedPrompt: (promptText: string) => void;
}

export const useComposerDraft = (): UseComposerDraftResult => {
  const [composerDraft, setComposerDraft] = useState('');
  const composerInputRef = useRef<HTMLTextAreaElement>(null);
  const pendingSelectionPositionRef = useRef<number | null>(null);

  useEffect(() => {
    const selectionPosition = pendingSelectionPositionRef.current;
    if (selectionPosition === null) {
      return;
    }

    const composerInput = composerInputRef.current;
    if (composerInput) {
      composerInput.focus();
      composerInput.setSelectionRange(selectionPosition, selectionPosition);
    }
    pendingSelectionPositionRef.current = null;
  }, [composerDraft]);

  const insertSavedPrompt = useCallback((promptText: string) => {
    const composerInput = composerInputRef.current;
    const insertion = insertSavedPromptText(
      composerDraft,
      promptText,
      composerInput?.selectionStart,
      composerInput?.selectionEnd,
    );

    pendingSelectionPositionRef.current = insertion.selectionStart;
    setComposerDraft(insertion.draft);
  }, [composerDraft]);

  return {
    composerDraft,
    setComposerDraft,
    composerInputRef,
    insertSavedPrompt,
  };
};